<div>
    
    <div class="header-table row" [ngClass]="!this.showBar ? 'm-0' : ''" >
        <ng-template *ngIf="this.showBar">
            <div class="col-12 col-lg-9">
                <div class="select-show">
                    Mostrar
                    <select (ngModelChange)="clearPagination($event)" [(ngModel)]="pageSize" class="select-input">
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                    </select>
                </div>
                <div class="input-search-group flex-grow-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="search-icon" width="20" viewBox="0 0 24 24"
                    fill="#8ca1b4" id="magnify">
                    <path
                    d="M9.5 3A6.5 6.5 0 0116 9.5c0 1.61-.59 3.09-1.56 4.23l.27.27h.79l5 5-1.5 1.5-5-5v-.79l-.27-.27A6.516 6.516 0 019.5 16a6.5 6.5 0 110-13m0 2C7 5 5 7 5 9.5S7 14 9.5 14 14 12 14 9.5 12 5 9.5 5z">
                </path>
            </svg>
            <input [formControl]="searchControl" placeholder="Pesquisar" type="text" class="search-input w-100" />
        </div>
    </div>
    <div class="col-12 col-lg-3">
        <button type="button" class="register-button btn-block" *ngIf="btnLabel" (click)="btnClick.emit()">{{
            btnLabel }}</button>
        </div>
    </ng-template>
    </div>
    <div class="container-table">
        <table class="table-planetun" [class.draggable]="draggable">
            <thead>
                <th *ngFor="let column of columns">
                    <span class="sort" (click)="sort(column)" [class.sort-asc]="column.order === 1"
                        [class.sort-desc]="column.order === -1" *ngIf="sortable; else columnName">
                        {{ column.name }}
                        <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4 12.9434L0.5 9.4434L1.205 8.7384L4 11.5284L6.795 8.7384L7.5 9.4434L4 12.9434Z"
                                fill="#ADB895" />
                            <path
                                d="M4 0.943359L7.5 4.44336L6.795 5.14836L4 2.35836L1.205 5.14836L0.5 4.44336L4 0.943359Z"
                                fill="#ADB895" />
                        </svg>
                    </span>
                    <ng-template #columnName>{{ column.name }}</ng-template>
                </th>
                <th *ngIf="optionsTemplate">Ações</th>
            </thead>
            <tbody [dragula]="draggable ? 'DRAGGABLE_TABLE' : undefined" [(dragulaModel)]="data"
                (dragulaModelChange)="onDrag.emit(data)">
                <tr
                    *ngFor="let item of (filteredData$ | async) | paginate: { itemsPerPage: pageSize, currentPage: page }">
                    <td *ngFor="let col of columns">
                        <ng-container *ngIf="col.mask">{{ item[col.field] | mask: col.mask }}</ng-container>
                        <ng-container *ngIf="col.date">
                            {{ item[col.field] | date: "dd/MM/yyyy 'às' HH:mm"}}
                        </ng-container>
                        <ng-container *ngIf="col.boolean">{{ item[col.field] ? col.boolean.trueAlias :
                            col.boolean.falseAlias }}</ng-container>
                        <ng-container *ngIf="!col.date && !col.mask && !col.boolean">{{ item[col.field] }}
                        </ng-container>
                    </td>
                    <td *ngIf="optionsTemplate">
                        <ng-container *ngTemplateOutlet="optionsTemplate; context: { item: item }"></ng-container>
                    </td>
                </tr>
            </tbody>
        </table>
        <div class="text-muted" *ngIf="!data.length">Nenhum dado cadastrado.</div>
        <div class="text-muted" *ngIf="data.length && (filteredData$ | async)?.length === 0">
            Nenhum dado encontrado. Tente rever os filtros.
        </div>
    </div>

    <div class="text-center">
        <pagination-controls previousLabel="Anterior" nextLabel="Próximo" (pageChange)="page = $event">
        </pagination-controls>
    </div>
</div>